export const DataContactOne = {
  sectionName: "POUR CONTACTER ",
  desc: "Vous pouvez nous contacter pour tous les travaux de nos domaines de compétances, nous demander un devis, nous demander des propositions techniques ou pour tout autre demande.",
  desc2: "Transformer vos idées en une réalité concrète",

  phone: "+2252722392898",
  phone2: "+2250712919191",
  email: "info@setelec-ci.com",
  email2: "recrutement@setelec-ci.com",
  address: "Abidjan Angré 8e Tranche, Lot : 610, Ilot : 41",
  mediaLinks: [
    { id: 1, name: "facebook", link: "" },
    // { id: 2, name: "twitter", link: "" },
    {
      id: 3,
      name: "linkedin-in",
      link: "https://ci.linkedin.com/company/setelec-sas",
    },
    // { id: 4, name: "instagram", link: "" },
  ],
  contactTitle: "Laissez Nous Un Message",
  contactDesc: "",

  workingDays: "Lundi - Vendredi",
  workingHours: "8:00 AM – 5:00 PM",

  littleIfo:
    "SETELEC est une société de services spécialisée dans le domaine de l’électricité Haute et Basse Tensions (HT/BT), l’Automatisme industriel, les Machines électriques, les Télécommunications, le Froid, la Climatisation, la Construction industrielle et la distribution de matériels industriels spécifiques.",

  slogan: "L’énergie au cœur du développement !",

  callTitle: "Contactez Nous au",
  callMsg:
    "SETELEC est fier de vous servir 24h/24 et 6j/7. Appelez-nous en cas de besoin.",
  mapUrl:
    "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3972.1635160574806!2d-3.981920025016033!3d5.392036194586957!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zNcKwMjMnMzEuMyJOIDPCsDU4JzQ1LjYiVw!5e0!3m2!1sfr!2sci!4v1746476275766!5m2!1sfr!2sci",

  googleMap: "https://www.google.com/maps?q=5.3920362,-3.9793451",

  needHelp: "Vous avez besoin d'aide ?",
  needHelpDesc:
    "Nous sommes là pour vous aider. N'hésitez pas à nous contacter pour toute question ou préoccupation.",

  copyright: "Copyright © 2025 SETELEC. Tous droits réservés par",
  companyName: "SETELEC",
};
